import React, { useContext } from 'react';
import { useBookingContext } from '../../Context';
import { BookerStateContext } from '../../hooks/useRuntimeCalBookingState';
import { BookingCancellation } from './BookingCancellation';

const BookingCancellationWrapper = () => {
    const bookerContext = useBookingContext();
    const [bookingState, bookingActions] = useContext(BookerStateContext);

    const { isBookingDryRun } = bookerContext;
    const { cancelBookingId } = bookingState;

    const showCancellation = !isBookingDryRun && cancelBookingId;

    if (!showCancellation) {
        return null;
    }

    return (
        <BookingCancellation
            bookingUid={cancelBookingId ?? ''}
            closeCancellation={() => bookingActions.setCancelBookingId(null)}
        />
    );
};

export default BookingCancellationWrapper;
